const SIZES = { sm: 14, md: 16, lg: 20 };

/**
 * Draws one outline icon (lucide) at the system stroke of 1.75 on its 24px grid.
 * Decorative by default; pass `label` when the icon is the only thing that carries meaning.
 */
const Icon = ({ icon: IconGlyph, size = 'md', label }) => {
  const pixels = SIZES[size] ?? SIZES.md;
  if (label) {
    return <IconGlyph className="comp-icon" size={pixels} strokeWidth={1.75} role="img" aria-label={label} />;
  }
  return <IconGlyph className="comp-icon" size={pixels} strokeWidth={1.75} aria-hidden="true" focusable="false" />;
};

export default Icon;
